{
  "_provenance": {
    "ns": "forms",
    "source": "the family form renderer: src/components/apply/**, src/pages/apply/** and components/intake/IntakeFieldInput.tsx (#2109 R2 lane L3)"
  },
  "address": {
    "asEntered": "As you entered it",
    "codes": {
      "added_street_type": "We added a street type — make sure it matches your address.",
      "matched_check_suggestion": "We matched your address to the postal database — check the suggested version.",
      "missing_component": "The {{part}} appears to be missing.",
      "no_result": "The address check returned no result for this address.",
      "not_verified": "We couldn’t verify this address against the postal database.",
      "standardized": "We standardized the address formatting.",
      "street_not_found": "We couldn’t find a street matching what you entered.",
      "street_required": "Enter a street address to check.",
      "unconfirmed_component": "We couldn’t confirm the {{part}}."
    },
    "components": {
      "administrative_area_level_1": "state / province",
      "locality": "city",
      "postal_code": "ZIP / postal code",
      "route": "street name",
      "street_number": "street number",
      "subpremise": "apartment / unit"
    },
    "continueWithMine": "Continue with my address",
    "correctedBody": "We found a close match in the postal database. Grant checks and cards ship to this address, so it’s worth a look.",
    "correctedTitle": "Double-check your address",
    "goBack": "Go back and edit",
    "keepAsEntered": "Keep as entered",
    "suggested": "Suggested",
    "unknownBody": "That’s okay — this never stops your application. If everything looks right, continue and we’ll use exactly what you entered.",
    "unknownBodyRenewal": "That’s okay — this never stops your renewal. If everything looks right, continue and we’ll use exactly what you entered.",
    "unknownTitle": "We couldn’t verify your address",
    "useSuggested": "Use suggested",
    "yours": "Your address"
  },
  "applyChrome": {
    "applyToTrf": "Apply to TRF",
    "estTime": "Est. time",
    "footer": "A program of the Tyler Robinson Foundation"
  },
  "applyLanding": {
    "alternatePrompt": "Already started?",
    "alternateSignIn": "Sign in",
    "checkingInvite": "Checking your invite link",
    "emailTaken": "There is already an account with this email. Sign in, or reset your password if you have forgotten it.",
    "emailTakenForgot": "Forgot your password?",
    "fields": {
      "email": "Email",
      "firstName": "First name",
      "password": "Password"
    },
    "lede": "The Tyler Robinson Foundation helps families of children with cancer with non-medical costs — travel, lodging, utilities, and more — so you can stay present for what matters most.",
    "meta": {
      "estTimeValue": "≈ 20 min",
      "review": "Review",
      "reviewValue": "A real case manager reviews every application",
      "saveAnytime": "Save anytime",
      "saveAnytimeValue": "Yes — pick up where you left off"
    },
    "points": {
      "minutes": "≈ 20 minutes to complete",
      "review": "A real case manager reviews every application",
      "save": "Save anytime — your progress is never lost"
    },
    "prescreenRequired": "Please answer a few quick questions first — it takes about a minute.",
    "signedIn": {
      "back": "Back to my account",
      "eyebrow": "Before you apply",
      "lede": "You’re signed in as <strong>{{email}}</strong>. Starting a new application here creates a separate account — and we don’t want that to happen by accident.",
      "ledeOnBehalf": "If you’re applying on behalf of a family, sign out first so their application gets its own account. Otherwise, head back to yours — nothing here has changed anything.",
      "metaNewApplication": "New application",
      "metaNewApplicationValue": "Creates its own account",
      "metaSignedInAs": "Signed in as",
      "renewalLede": "Your family’s grant is up for renewal, so you don’t need a new application. Start your renewal from your account.",
      "signOutAndStart": "Sign out and start application",
      "startRenewal": "Start your renewal",
      "title": "You’re already signed in.",
      "yourAccount": "your account"
    },
    "signupFailedDescription": "Something went wrong. Please try again.",
    "signupFailedTitle": "Signup failed",
    "title": "You carry enough. <br/>Let’s carry <em>this</em> part.",
    "validation": {
      "firstNameRequired": "First name is required",
      "invalidEmail": "Invalid email address",
      "passwordLowercase": "Must contain at least one lowercase letter",
      "passwordMin": "Password must be at least 8 characters",
      "passwordNumber": "Must contain at least one number",
      "passwordUppercase": "Must contain at least one uppercase letter"
    }
  },
  "documents": {
    "addedByCareTeam": "Added by your care team",
    "allRequiredNote": "Every document below is required to submit your application.",
    "allRequiredNoteRenewal": "Every document below is required to submit your renewal.",
    "alsoInBody": "{{file}} is also in {{slot}}. That’s fine if the same document covers both.",
    "alsoInTitle": "Also added elsewhere",
    "billStatements_one": "Bill statement",
    "billStatements_other": "Bill statement(s)",
    "capOverflow_one": "Only {{count}} more allowed for {{slot}} — {{files}} not added.",
    "capOverflow_other": "Only {{count}} more allowed for {{slot}} — {{files}} not added.",
    "childPhoto": "Photo of your child",
    "chooseFile": "Choose file",
    "choosePhoto": "Choose photo",
    "choosePhotoOrFile": "Choose photo or file",
    "dismiss": "Dismiss",
    "dismissFile": "Dismiss {{file}}",
    "dropEmptyBody": "Use the upload button instead, or drag the photo to your Desktop first and drop it from there.",
    "dropEmptyTitle": "That file didn’t come through",
    "dropHere": "Drop to upload",
    "dropHint": "or drag files here",
    "duplicateBody": "This is the same file as {{file}}. Upload a new scan.",
    "duplicateTitle": "Already added",
    "eyebrow": "Supporting documents",
    "familyPhoto": "Photo of your family",
    "fileRules": "JPG, PNG or PDF, up to {{max}} MB each",
    "maxReached_one": "Maximum {{count}} reached",
    "maxReached_other": "Maximum {{count}} reached",
    "missingTile": "Add this document before you continue.",
    "openFile": "Open {{file}}",
    "optionalChip": "opt",
    "refusedEmpty": "“{{file}}” is empty. Choose the file again, or pick another one.",
    "refusedSize": "“{{file}}” is too large. Each file can be up to {{max}} MB.",
    "refusedType": "“{{file}}” can’t be added. Only JPEG, PNG or PDF files are accepted.",
    "remove": "Remove",
    "removedTitle": "Removed {{file}}",
    "removeFailedTitle": "Couldn’t remove the file",
    "removeFile": "Remove {{file}}",
    "replace": "Replace",
    "replaceBody": "Replace \"{{file}}\" with \"{{next}}\"? Your previously uploaded \"{{file}}\" will no longer be attached.",
    "replaceTitle": "Replace {{file}}?",
    "requiredChip": "Required",
    "requiredMissingBody": "Please upload {{slots}} before you continue.",
    "requiredMissingTitle": "Still needed before you can submit",
    "restoreFailedTitle": "Couldn’t bring the file back",
    "retry": "Retry",
    "retryFile": "Retry {{file}}",
    "skipNote": "All optional — skip what you don’t have.",
    "skipNoteSomeRequired": "Documents marked Required are needed to submit your application.",
    "skipNoteSomeRequiredRenewal": "Documents marked Required are needed to submit your renewal.",
    "title": "Upload the following documents",
    "undo": "Undo",
    "uploadedFile": "{{file}} uploaded",
    "uploadErrorNetwork": "The connection dropped before this file finished uploading. Check your signal and try again.",
    "uploadErrorSize": "This file is too large. Each file can be up to {{max}} MB.",
    "uploadErrorType": "This file can’t be added. Use a JPG, PNG or PDF.",
    "uploadFailedFile": "{{file}} could not be uploaded",
    "uploadFailedRow": "This file could not be uploaded. Try again.",
    "uploadingFile": "Uploading {{file}}",
    "uploadLabel": "Upload {{slot}}"
  },
  "gate": {
    "loadFailedApplication": "We couldn’t load your application just now.",
    "loadFailedPrescreen": "We couldn’t load these questions just now.",
    "loadFailedRenewal": "We couldn’t load your renewal just now.",
    "loading": "Loading the form"
  },
  "input": {
    "file": {
      "choose": "Choose a file",
      "failed": "That file could not be uploaded.",
      "none": "No file uploaded.",
      "replace": "Replace this file",
      "uploaded": "Uploaded file",
      "uploading": "Uploading…"
    },
    "kept": {
      "caption": "Kept from an earlier answer — no longer offered in the list above.",
      "groupLabel": "{{label}} — kept from an earlier answer"
    }
  },
  "inviteStop": {
    "codePlaceholder": "e.g. {{example}}",
    "continueWithoutCode": "Continue without a code",
    "loading": "Loading"
  },
  "language": {
    "consentEnglish": "This consent is in English; the English text is the one you agree to.",
    "machine": "This form was translated by machine. TRF has not reviewed the translation yet.",
    "notOffered": "This form isn’t available in your language yet, so it’s shown in English.",
    "shownInEnglish": "shown in English"
  },
  "prescreenChrome": {
    "ageUnit": "years",
    "beforeYouBegin": "Before you begin",
    "contactEmail": "Email",
    "contactPhone": "Phone",
    "continueAnyway": "Continue to the application anyway",
    "estTimeValue": "≈ 1 minute",
    "stillToAnswer": "Still to answer: {{items}}",
    "whenReady": "When you’re ready"
  },
  "referral": {
    "contactLabel": "Who told you about TRF?",
    "contactPlaceholder": "e.g. a nurse’s name, or however you know them",
    "eyebrow": "No code? Tell us who referred you",
    "hospitalLabel": "Hospital or clinic",
    "hospitalPlaceholder": "Start typing your hospital’s name",
    "matches": "Matching hospitals",
    "notListed": "My hospital isn’t listed",
    "optional": "Every field below is optional — answer what you know, skip what you don’t.",
    "otherLabel": "Hospital name",
    "otherPlaceholder": "Your hospital or clinic’s name",
    "searching": "Searching…",
    "searchInstead": "Search for my hospital instead"
  },
  "select": {
    "pickDriverFirst": "Select {{driver}} first",
    "pickPreviousFirst": "Select the previous answer first",
    "placeholder": "Select…"
  },
  "verifyEmail": {
    "checkInboxLede": "We sent a confirmation link to your email. Click it to verify your address and continue your application.",
    "checkInboxTitle": "Check your inbox",
    "confirmedLabel": "Confirmed",
    "confirmedLede": "Your address is verified. Head back to your application whenever you’re ready.",
    "confirmedTitle": "Email confirmed — you can keep going",
    "confirmingTitle": "Confirming your email…",
    "continue": "Continue application",
    "documentLabel": "Verify email",
    "expired": "The link may have expired.",
    "failedFallback": "The link may have expired or already been used.",
    "failedLabel": "Verification failed",
    "failedTitle": "We couldn’t confirm that link",
    "justAMoment": "Just a moment",
    "resend": "Resend confirmation email",
    "resendFailed": "We couldn’t send the email. Please try again.",
    "resendRateLimited": "You’ve asked for a few emails already. Wait a few minutes, then try again.",
    "resent": "Sent — check your inbox",
    "sending": "Sending…",
    "sendNew": "Send a new confirmation email"
  },
  "wizard": {
    "canadaClosedBody": "Please contact the TRF team and we’ll help you with your application.",
    "canadaClosedTitle": "Canadian families apply through TRF directly this year",
    "canadaTitle": "{{title}} (Canada)",
    "checkingAddress": "Checking address…",
    "cycleClosedBody": "Applications are closed right now, so this application can’t be submitted. If you have questions, email melanie@trf.org.",
    "cycleClosedBodyRenewal": "Renewals are closed right now, so this renewal can’t be submitted. If you have questions, email melanie@trf.org.",
    "cycleClosedTitle": "Applications are closed",
    "cycleClosedTitleRenewal": "Renewals are closed",
    "loadFailedTitle": "Couldn’t load your application",
    "loadFailedTitleRenewal": "Couldn’t load your renewal",
    "loading": "Loading your application…",
    "loadingRenewal": "Loading your renewal…",
    "moreInfo": {
      "askedLabel": "TRF asked about:",
      "attribution": "From your TRF case manager:",
      "body": "Update what TRF asked about, then go to the last step and send it again.",
      "fieldNote": "TRF asked about this question.",
      "shownInEnglish": "Shown in English, as TRF wrote it.",
      "title": "TRF needs something from you"
    },
    "prescreenMissContact": "If anything here looks wrong, write to TRF at {{email}} or call {{phone}}.",
    "progress": {
      "label": "Application progress",
      "labelRenewal": "Renewal progress",
      "listLabel": "Steps",
      "menuToggle": "All steps",
      "step": "Step {{current}} of {{total}}"
    },
    "refreshAndRetry": "Please refresh and try again.",
    "renewal": {
      "body": "We’ve pre-filled what we already know about your family — please review and update anything that’s changed. Renewals are invitation-based; submitting here lets your TRF team review your request.",
      "regionCycleTitle": "Your renewal.",
      "secondaryContactAuthorizedLabel": "Is the secondary contact authorized to discuss and make decisions regarding this renewal on behalf of the family?",
      "titleGeneric": "Signature Grant renewal (year 2+)",
      "titleYear": "Signature Grant renewal — {{year}}"
    },
    "renewalNotEligibleApply": "Start an application",
    "renewalNotEligibleBody": "Renewal is for families who already have a TRF grant. If your family is new to TRF, start with an application.",
    "renewalNotEligibleTitle": "No grant to renew yet",
    "renewalYearCapBody": "A Signature grant renews for up to three years, and your family’s grant is in its third year, so there is no renewal to start. Your TRF case manager can talk with you about what comes next.",
    "renewalYearCapTitle": "Your grant is in its final year",
    "renewalYearReadOnly": "TRF sets your renewal year.",
    "repick": {
      "noteFromCA": "Your earlier answer was {{answer}} in Canadian dollars. Please choose your band in US dollars.",
      "noteFromUS": "Your earlier answer was {{answer}} in US dollars. Please choose your band in Canadian dollars."
    },
    "requiredAnswersMissingBody": "Please answer {{fields}} before you submit.",
    "requiredAnswersMissingTitle": "A few answers are still needed",
    "saveAndContinue": "Save & continue",
    "savedJustNow": "Saved ✓ · just now",
    "saveFailedBody": "Nothing was lost — please try again.",
    "saveFailedTitle": "Couldn’t save your progress",
    "saving": "Saving…",
    "startFailedTitle": "Couldn’t start your application",
    "startFailedTitleRenewal": "Couldn’t start your renewal",
    "startRefused": {
      "codeHeading": "Enter your code to continue",
      "cycleClosed": "This application round has closed, so a new application can’t be started. If you have questions, email melanie@trf.org.",
      "newFamiliesSoon": "New families can start an application from {{date}}. Right now this round is open to families renewing their TRF grant. If you are renewing, enter your code below.",
      "referral": "We couldn’t find a valid application code or link for your account. If your social worker or the TRF team gave you a code, enter it below.",
      "support": "Need help? Reach the Tyler Robinson Foundation team at",
      "title": "We couldn’t start your application"
    },
    "steps": {
      "documents": "Supporting documents",
      "health": "Health information",
      "review": "Review & submit"
    },
    "submit": "Submit application",
    "submitConsent": {
      "eyebrow": "Final step",
      "title": "How TRF uses your application",
      "titleRenewal": "How TRF uses your renewal"
    },
    "submitFailedBody": "Your answers are saved — please try again.",
    "submitFailedTitle": "Couldn’t submit your application",
    "submitFailedTitleRenewal": "Couldn’t submit your renewal",
    "submitRenewal": "Submit renewal",
    "submitting": "Submitting…",
    "uploadFailed": "The file wasn’t attached. Please try again."
  }
}
